export * from './ng4-files';



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/node_modules/angular4-files-upload/src/app/index.ts